import { useState } from "react";

const dealers = ["Tümü", "Teknoloji Dünyası", "Bilgisayar Plaza", "Ofis Market", "Ana Bayi"];
const categories = ["Tümü", "Elektronik", "Aksesuar", "Ofis", "Giyim"];
const brands = ["Tümü", "Logitech", "Samsung", "Apple", "Dell", "HP", "Corsair"];

const months = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran"];
const allData = [
  { month: "Ocak", sales: 45000, cost: 28000, profit: 17000, qty: 145 },
  { month: "Şubat", sales: 52000, cost: 32000, profit: 20000, qty: 168 },
  { month: "Mart", sales: 48000, cost: 29500, profit: 18500, qty: 152 },
  { month: "Nisan", sales: 61000, cost: 38000, profit: 23000, qty: 195 },
  { month: "Mayıs", sales: 58000, cost: 35500, profit: 22500, qty: 187 },
  { month: "Haziran", sales: 72000, cost: 44000, profit: 28000, qty: 234 },
];

export default function SixMonthSalesReport() {
  const [year, setYear] = useState("2026");
  const [dealer, setDealer] = useState("");
  const [category, setCategory] = useState("");
  const [brand, setBrand] = useState("");

  const totalSales = allData.reduce((s, d) => s + d.sales, 0);
  const totalProfit = allData.reduce((s, d) => s + d.profit, 0);
  const totalQty = allData.reduce((s, d) => s + d.qty, 0);
  const maxSales = Math.max(...allData.map((d) => d.sales));

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-primary-500 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">6 Aylık Satışlar Rapor Kriterleri</span>
          <button onClick={() => { setYear("2026"); setDealer(""); setCategory(""); setBrand(""); }} className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer">Temizle</button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Yıl</label>
            <select value={year} onChange={(e) => setYear(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer">
              <option value="2026">2026</option>
              <option value="2025">2025</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Cari Bayi</label>
            <select value={dealer} onChange={(e) => setDealer(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer">
              {dealers.map((d) => <option key={d} value={d === "Tümü" ? "" : d}>{d}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Kategori</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer">
              {categories.map((c) => <option key={c} value={c === "Tümü" ? "" : c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Marka</label>
            <select value={brand} onChange={(e) => setBrand(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer">
              {brands.map((b) => <option key={b} value={b === "Tümü" ? "" : b}>{b}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <p className="text-xs text-foreground-400 mb-1">6 Aylık Toplam Satış</p>
          <p className="text-xl font-bold text-foreground-950">${totalSales.toLocaleString("en-US")}</p>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <p className="text-xs text-foreground-400 mb-1">6 Aylık Toplam Kâr</p>
          <p className="text-xl font-bold text-primary-600">${totalProfit.toLocaleString("en-US")}</p>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <p className="text-xs text-foreground-400 mb-1">Toplam Satılan Adet</p>
          <p className="text-xl font-bold text-foreground-950">{totalQty}</p>
        </div>
      </div>

      <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
        <h3 className="text-sm font-semibold text-foreground-950 mb-4">Aylık Satış Trendi</h3>
        <div className="flex items-end justify-around gap-2 h-48">
          {allData.map((item, i) => (
            <div key={i} className="flex flex-col items-center gap-1 flex-1">
              <span className="text-xs font-medium text-foreground-700">${(item.sales / 1000).toFixed(0)}K</span>
              <div className="w-full flex gap-0.5 items-end h-32">
                <div className="flex-1 bg-primary-400/80 rounded-t-sm" style={{ height: `${(item.sales / maxSales) * 100}%` }}></div>
                <div className="flex-1 bg-accent-400/60 rounded-t-sm" style={{ height: `${(item.profit / maxSales) * 100}%` }}></div>
              </div>
              <span className="text-[10px] text-foreground-400">{item.month}</span>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-center gap-4 mt-3">
          <div className="flex items-center gap-1.5"><div className="w-3 h-3 bg-primary-400/80 rounded-sm"></div><span className="text-xs text-foreground-500">Satış</span></div>
          <div className="flex items-center gap-1.5"><div className="w-3 h-3 bg-accent-400/60 rounded-sm"></div><span className="text-xs text-foreground-500">Kâr</span></div>
        </div>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Ay</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Satılan Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Satış Tutarı</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Maliyet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Kâr</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Kâr Marjı</th>
            </tr>
          </thead>
          <tbody>
            {allData.map((item, idx) => (
              <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 font-medium text-foreground-900">{item.month}</td>
                <td className="px-4 py-3 text-center text-foreground-900">{item.qty}</td>
                <td className="px-4 py-3 text-right font-semibold text-foreground-900">${item.sales.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right text-foreground-500">${item.cost.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right font-semibold text-primary-600">${item.profit.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right text-foreground-500">%{((item.profit / item.sales) * 100).toFixed(1)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {allData.map((item, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-foreground-900">{item.month}</p>
              <p className="text-sm font-bold text-foreground-900">${item.sales.toLocaleString("en-US")}</p>
            </div>
            <p className="text-xs text-foreground-400 mt-1">{item.qty} adet · Kâr: ${item.profit.toLocaleString("en-US")} · Marj: %{((item.profit / item.sales) * 100).toFixed(1)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}